var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { LeanClient } from 'lean4web/client/src/editor/leanclient';
import * as React from 'react';
import { useState } from 'react';
var Connection = /** @class */ (function () {
    function Connection() {
        var _this = this;
        this.game = undefined; // We only keep a connection to a single game at a time
        this.leanClient = null;
        /** If not already started, starts the Lean client. resolves the returned promise as soon as a
         * Lean client is running.
         */
        this.startLeanClient = function (game) {
            return new Promise(function (resolve) {
                var leanClient = _this.getLeanClient(game);
                if (leanClient.isRunning()) {
                    resolve(leanClient);
                }
                else {
                    if (!leanClient.isStarted()) {
                        leanClient.start();
                    }
                    leanClient.restarted(function () {
                        // This keep alive message is not recognized by the server,
                        // but it makes sure that the websocket connection does not
                        // time out after 60 seconds.
                        setInterval(function () { leanClient.sendNotification('$/keepAlive', {}); }, 5000);
                        resolve(leanClient);
                    });
                }
            });
        };
    }
    Connection.prototype.getLeanClient = function (game) {
        if (this.game !== game) {
            if (this.leanClient) {
                this.leanClient.stop(); // Stop previous Lean client
            }
            this.game = game;
            // Start a new Lean client for the new `gameId`.
            var socketUrl = ((window.location.protocol === "https:") ? "wss://" : "ws://") + window.location.host + '/websocket/' + game;
            var uri = monaco.Uri.parse('file:///');
            this.leanClient = new LeanClient(socketUrl, undefined, uri, function () { });
        }
        return this.leanClient;
    };
    return Connection;
}());
export { Connection };
export var connection = new Connection();
export var ConnectionContext = React.createContext(null);
export var useLeanClient = function (gameId) {
    var leanClient = connection.getLeanClient(gameId);
    var _a = __read(useState(leanClient.isStarted()), 2), leanClientStarted = _a[0], setLeanClientStarted = _a[1];
    React.useEffect(function () {
        var t1 = leanClient.restarted(function () { console.log("START"); setLeanClientStarted(true); });
        var t2 = leanClient.stopped(function () { console.log("STOP"); setLeanClientStarted(false); });
        return function () { t1.dispose(); t2.dispose(); };
    }, [leanClient, setLeanClientStarted]);
    return { leanClientStarted: leanClientStarted, leanClient: leanClient };
};
